import StandUserTable from "./stand-users-table";

export default StandUserTable;
